module.exports = __webpack_public_path__ + "img/branches-bg.1d090cfb.webp";